export enum ClientSideStorageType {
  Unknown = 0,
  Necessary = 1 << 0, // 0001
  Functional = 1 << 1, // 0010
  // NV-4847 Analytics cookies will, for now, be classified as necessary. Keep if this changes in the future.
  Analytics = 1 << 2, // 0100
}
